
import React from 'react';
import styled from 'styled-components';
import ReviewsList from '../components/ReviewsList';



const Content = styled.div`
  padding-top: 100px;
  padding-left: ${({ isSidebarOpen }) => (isSidebarOpen ? '200px' : '0')};
  transition: padding-left 0.3s ease;
  width: 100%;
  background: #2193b0;  /* fallback for old browsers */
  color: black; 
`;


const Home = ({
    reviewsData,
    onReportInappropriate,
    currentPage,
    totalReviews,
    onNextPage,
    onPreviousPage,
    isSidebarOpen,
}) => {
    return (
        <Content isSidebarOpen={isSidebarOpen}>
            <ReviewsList
                reviews={reviewsData}
                onReportInappropriate={onReportInappropriate}
            />
            <div>
                <button onClick={onPreviousPage} disabled={currentPage === 1}>Previous</button>
                <button onClick={onNextPage} disabled={currentPage * 10 >= totalReviews}>Next</button>
            </div>
        </Content>
    );
};

export default Home;
